import { useCallback, useEffect } from 'react'
import { useFetch } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'auth/hooks'

const STABLE_EMPTY_ARRAY = []

export const useCredentialTypes = (onResultUpdate) => {
  const [request, { result, loading, called }] = useFetch(
    'Error Credential Types.  Please refresh the page and try again',
  )
  const currentOrg = useCurrentOrg()
  const refetch = useCallback(async () => {
    return request({
      onSuccess: result => {
        onResultUpdate && onResultUpdate(result)
      },
      method: 'get',
      url: `/identification-types`,
      config: {
        queryStringParameters: { reporting: true }
      }
    })
  }, [currentOrg.id, request])

  useEffect(() => { refetch() }, [refetch])

  return {
    useCredentialTypes: result || STABLE_EMPTY_ARRAY,
    loading: loading || !called,
    refetch,
  }
}
